import "../chunk-D57E6H3M.mjs";

// src/utils/fadeOutRemovedPopup.ts
function fadeOutRemovedPopup(wrapper, container, contentSelector) {
  const ghost = wrapper.cloneNode(true);
  const content = ghost.querySelector(contentSelector);
  if (!content) return;
  ghost.setAttribute("aria-hidden", "true");
  ghost.inert = true;
  ghost.style.pointerEvents = "none";
  ghost.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"));
  content.dataset.state = "closed";
  container.appendChild(ghost);
  if (getComputedStyle(content).animationName === "none") {
    ghost.remove();
    return;
  }
  const remove = () => ghost.remove();
  content.addEventListener("animationend", remove, { once: true });
  content.addEventListener("animationcancel", remove, { once: true });
}
export {
  fadeOutRemovedPopup
};
//# sourceMappingURL=fadeOutRemovedPopup.mjs.map